import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export interface ClientsResponse {
    clients: any[];
    page: number;
    totalPages: number;
}

export const getClientsInfo = async (page: number, filters: any) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/clients`, { params: {page, size: 10, ...filters },
            withCredentials: true
        });

        const transformedClients = response.data.data.clients.content.map((item: any) => ({
            NOMBRE: item.name,
            ATC: item.atc,
            CLAVE: item.uniqueCode,
            ESTADO: item.state,
            ID: item.id
        }));

        return {
            clients: transformedClients || [],
            page: response.data.data.clients.number,
            totalPages: response.data.data.clients.totalPages,
        }

    } catch (error) {
        throw error;
    }
}

export const createClient = async (newClientDTO: any) => {
    try {
        return await axios.post(`${API_BASE_URL}/clients`, newClientDTO, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al crear cliente.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
}

export const getFiltersForClients = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/clients/admin/filters`, {withCredentials: true});
        return response.data.data.filters;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al obtener filtros.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
}

export const getClientByUniqueCode = async (uniqueCode: string) => {
    try{
        const response = await axios.get(`${API_BASE_URL}/clients/complete/${uniqueCode}`, { withCredentials: true});
        return response.data.data.client;
    }
    catch(error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al obtener cliente.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
}

export const updateClientService = async (clientDto: any) => {
    try{
        const response = await axios.put(`${API_BASE_URL}/clients/${clientDto.id}`, clientDto , { withCredentials: true});
    }
    catch(error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al actualzar cliente.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
}